import { render, staticRenderFns } from "./ArticleCategoryDropdownFilters.vue?vue&type=template&id=19f95868&"
import script from "./ArticleCategoryDropdownFilters.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryDropdownFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports